module.exports = __webpack_public_path__ + "static/media/thomas_solmonte_coleman_swinney_fyfe.4fef4376.gif";